import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { translate } from "react-i18next";

import { Button } from "ia-react-ui-components";

export class Section_Intro extends Component {
  constructor(props) {
    super();
  }

  goToPage = direction => {
    if (direction === "previous") {
      this.props.history.push("/");
    } else {
      this.props.history.push("/SectionOne");
    }
  };

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Row>
          <Col sm="12">
            <h1>{t("section_intro.header1")}</h1>
            <p>
              {t("section_intro.paragraph1")}{" "}
              <a href="tel:18005497227">
                <u>{t("common.phone")}</u>
              </a>
            </p>
            <p>{t("section_intro.paragraph2")}</p>
            <ul>
              <li>{t("section_intro.list1")}</li>
              <li>{t("section_intro.list2")}</li>
              <li>{t("section_intro.list3")}</li>
              <li>{t("section_intro.list4")}</li>
              <li>{t("section_intro.list5")}</li>
              <li>{t("section_intro.list6")}</li>
            </ul>
            <p>{t("section_intro.paragraph3")}</p>
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <Button id="btnPrev" onClick={() => this.goToPage("previous")}>
              {t("common.previous")}
            </Button>
          </Col>
          <Col sm="2">
            <Button id="btnNext" onClick={() => this.goToPage("next")}>
              {t("common.next")}
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default translate("translate")(Section_Intro);
